module.exports = __webpack_public_path__ + "static/media/builtinv2-Accum battery.8789d250.png";